export const datas1 = [
  "one",
  "two",
  "three",
  "four",
  "five",
  "six",
  "seven",
  "eight",
  "nine",
  "ten",
  "eleven",
  "twelve",
  "thirteen",
  "fourteen",
  "fifteen",
  "sixteen",
  "seventeen",
  "eighteen",
  "nineteen",
  "twenty",
];
export const datas2 = [
  "twentyOne",
  "twentyTwo",
  "twentyThree",
  "twentyFour",
  "twentyFive",
  "twentySix",
  "twentySeven",
  "twentyEight",
  "twentyNine",
  "thirty",
  "thirtyOne",
  "thirtyTwo",
  "thirtyThree",
  "thirtyFour",
  "thirtyFive",
  "thirtySix",
  "thirtySeven",
  "twenty",
];
export const datas3 = [
  "thirtyEight",
  "thirtyNine",
  "forty",
  "fortyOne",
  "fortyTwo",
  "fortyThree",
  "fortyFour",
  "fortyFive",
  "fortySix",
  "fortySeven",
  "fortyEight",
  "fortyNine",
  "fifty",
  "fiftyOne",
  "fiftyTwo",
  "fiftyThree",
  "fiftyFour",
  "fiftyFive",
  "fiftySix",
  "twenty",
];
export const navList = [
  {
    id: 1,
    name: "aboutLink",
    component: "jumpabout",
  },
  {
    id: 2,
    name: "workLink",
    component: "jumpwork",
  },
  {
    id: 3,
    name: "resourceLink",
    component: "jumpresource",
  },
  {
    id: 4,
    name: "contactLink",
    component: "jumpcontact",
  },
];
export const aboutList = [
  {
    url: require("../../assets/images/imgs/Group 3867.png"),
    title: "post",
  },
  {
    url: require("../../assets/images/imgs/Group 3868.png"),
    title: "operation",
  },
  {
    url: require("../../assets/images/imgs/Group 3869.png"),
    title: "information",
  },
  {
    url: require("../../assets/images/imgs/Group 3870.png"),
    title: "communicate",
  },
  {
    url: require("../../assets/images/imgs/Group 3871.png"),
    title: "training",
  },
  {
    url: require("../../assets/images/imgs/Group 3872.png"),
    title: "consultant",
  },
];
export const workList = [
  {
    url: require("../../assets/images/imgs/Group 3836.png"),
    title: "stepNameOne",
    synopsis: "stepContentOne",
  },
  {
    url: require("../../assets/images/imgs/Group 3844.png"),
    title: "stepNameTwo",
    synopsis: "stepContentTwo",
  },
  {
    url: require("../../assets/images/imgs/Group 3850.png"),
    title: "stepNameThree",
    synopsis: "stepContentThree",
  },
  {
    url: require("../../assets/images/imgs/Group 3843.png"),
    title: "stepNameFour",
    synopsis: "stepContentFour",
  },
  {
    url: require("../../assets/images/imgs/Group 3837.png"),
    title: "stepNameFive",
    synopsis: "stepContentFive",
  },
  {
    url: require("../../assets/images/imgs/Group 3838.png"),
    title: "stepNameSix",
    synopsis: "stepContentSix",
  },
];
export const contactListEn = [
  {
    name: "Amanda Zhan | Business Manager",
    tel: "+86 132 5731 1835",
    mail: "amanda.zhan@elitego.cn",
    linkedin:
      "https://www.linkedin.com/in/amanda-zhan-46b0b5324/",
    facebook: "https://www.facebook.com/share/15rNsuuxc8/?mibextid=wwXIfr",
  },
  {
    name: "John Han | Business Manager",
    tel: "+86 152 1085 0339",
    mail: "john.han@elitego.cn",
    linkedin: "https://www.linkedin.com/in/john-han-elitego-talent/",
    facebook: "https://www.facebook.com/Housespace.prefab/",
  },
];
export const contactListZh = [
  {
    headquartersAddress: "北京市海淀区德惠路1号院14号楼1至2层3-178",
    branchAddress:
      "中国湖南省长沙市开福区月湖街道匍园路20号聚恒科技园1栋1601房",
    tel: "+86 132 5731 1835",
    WeChat: "Jingyipaidan",
    mail: "amanda.zhan@elitego.cn",
  },
];
